import React, { Component } from 'react';
import { connect } from 'react-redux';
import connectCommon from '../common/common-hoc';
import * as actionCreator from '../../redux/actions/data-action';
import { taskSegment } from './common/task-utility';

import {
	AssessmentInstruction,
	AssessmentStart,
	AssessmentEnd,
} from '../assessment';

import { getPracticeComponent } from './practice-tasks';
import { getTaskComponent } from './tasks';

class AssessmentTasks extends Component {
	constructor(props) {
		super(props);

		this.updated = false;
		this.checkResume = false;
	}

	componentDidMount() {
		const { history, resumeSession } = this.props;
		const resumeLocation = localStorage.getItem('resumeLocation');
		const resumeData = localStorage.getItem('resumeData');
		const resumeExpiry = parseInt(localStorage.getItem('resumeExpiry'));

		if (resumeLocation && resumeData) {
			if (resumeExpiry && new Date() > resumeExpiry) {
				localStorage.clear();
			} else {
				resumeSession(JSON.parse(resumeData));
				history.push(resumeLocation);
			}
		}

		document.oncontextmenu = () => false;
	}

	componentDidUpdate() {
		const { screens, match, history, resumeSession, logToSentry, data, updateValue } = this.props;

		let currentIndex = screens.map(screen => screen.url).indexOf(match.url);
		const resumeLocation = localStorage.getItem('resumeLocation');
		const resumeData = localStorage.getItem('resumeData');
	

		if (currentIndex === -1 && match.url !== '/Assessment/Tasks/ItemList/TaskComplete' && resumeLocation && resumeData) {
			logToSentry('error', 'Current index equal to -1. Attempting to restore last known good', null, null, 
			{
				filename: 'assessmentScreenData.json',
				data: screens
			})

			resumeSession(JSON.parse(resumeData));

			this.checkResume = true;

			history.push(resumeLocation);
		}

		if (this.checkResume && currentIndex !== -1) {
			logToSentry('info', 'Last known good successfully restored', null, null, 
			{
				filename: 'assessmentScreenData.json',
				data: screens
			})
			
			this.checkResume = false;
		}
	}

	getPreviousLink() {
		const { screens, match } = this.props;
		const { segment } = match.params;
		const currentIndex = segment === taskSegment.TASKCOMPLETE ? screens.length : screens.map(screen => screen.url).indexOf(match.url);
		const previousIndex = currentIndex - 1;

		if (currentIndex > 0) {
			return screens[previousIndex].url;
		} else {
			return null;
		}
	}

	getNextLink() {
		const { data, screens, match, logToSentry } = this.props;
		const { type, segment } = match.params;
		const currentIndex = screens.map(screen => screen.url).indexOf(match.url);
		const nextIndex = currentIndex + 1;

		if (currentIndex === -1 && match.url !== '/Assessment/Tasks/ItemList/TaskComplete') {
			logToSentry('error', 'Current index equal to -1', null, null,
			{
				filename: 'assessmentScreenData.json',
				data: screens
			})
		}

		if (nextIndex > screens.length) {
			logToSentry('error', 'Next index greater than screen array size', null, null,
			{
				filename: 'assessmentScreenData.json',
				data: screens
			})
		}

		if (currentIndex >= 0 && nextIndex < screens.length) {
			return screens[nextIndex].url;
		} else if(segment !== taskSegment.TASKCOMPLETE) {
			return `/Assessment/Tasks/${type}/${taskSegment.TASKCOMPLETE}`;
		} else {
			return '/Assessment/Complete';
		}
	}

	render() {
		const { versionID, match } = this.props;
		const { segment } = match.params;

		const segmentProps = {
			previousLink: this.getPreviousLink(),
			nextLink: this.getNextLink(),
			...this.props
		};

		switch (segment) {
			case taskSegment.INSTRUCTION:
				return <AssessmentInstruction {...segmentProps} />

			case taskSegment.PRACTICE:
				const Practice = getPracticeComponent(versionID);
				return <Practice {...segmentProps} />

			case taskSegment.PRACTICECOMPLETE:
				return <AssessmentStart {...segmentProps} />

			case taskSegment.TASK:
				const Task = getTaskComponent(versionID);
				return <Task {...segmentProps} />

			case taskSegment.TASKCOMPLETE:
				return <AssessmentEnd {...segmentProps} />

			default:
				return <AssessmentInstruction {...segmentProps} />
		}
	}
}

const mapStateToProps = state => {
	const { data } = state;
	const { versionID, screens, tasks, outcomes } = data;
	return { data, versionID, screens, tasks, outcomes };
};

export default connect(mapStateToProps, actionCreator)(connectCommon(AssessmentTasks));